import { Tooltip } from "@mui/material";

export const BlurredValue = ({ tooltip, children }: { tooltip: string; children: React.ReactNode }) => (
  <Tooltip title={tooltip} arrow>
    <span className="blur-sm cursor-help">{children}</span>
  </Tooltip>
);
